export default {
    LOCATION: 'Location',
    SIZE_LOCATION: 'Size-Location',
    VRBO: 'Vrbo',
    DEFAULT: 'Default',
    TIMEOUT: 'Timeout',
    TIMEOUT_JEL: 'TimeoutJel',
    AAP_INELIGIBLE: 'AddProperty-Ineligible',
    ADD_PROPERTY: 'AddProperty'
};
